import React from 'react';

import { useSelector } from 'react-redux';

import classNames from 'classnames';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const CompanyTypes = ({ label = 'Types', value: selectedTypes, alias = 'types', onFilter, ...props }) => {
  const isSomethingSelected = !!selectedTypes?.length;
  const availableTypes = useSelector(({ companyTypes }) => companyTypes.items);

  const handleSelection = ({ target: { value } }) => {
    onFilter(alias, value);
  };

  return (
    <FormControl variant="outlined" className={classNames(css.wrapper, props.className)}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={selectedTypes || []}
        onChange={handleSelection}
        label={label}
        endAdornment={isSomethingSelected && <ClearButton withMargin onClick={() => onFilter(alias, null)} />}
        className={isSomethingSelected ? css.active : ''}
      >
        {availableTypes.map((type, i) => (
          <MenuItem key={`type_${i}`} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CompanyTypes;
